// src/components/LeftNavigationBar.js
import React from 'react';
import { Paper, Box, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';

const LeftNavigationBar = () => {
  const location = useLocation();

  // 현재 접속한 메뉴에 따라 표시할 제목 결정 (공사현황은 표시하지 않음)
  let title = '';
  if (location.pathname === '/estimate') {
    title = '견적관리';
  } else if (location.pathname === '/material') {
    title = '자재관리';
  } else if (location.pathname === '/outsourcing') {
    title = '외주관리';
  }

  // title이 없으면 렌더링하지 않음
  if (!title) return null;

  return (
    <Box style={{ flex: '0 1 200px', minWidth: '120px' }}>
      <Paper 
         elevation={3} 
         sx={{
           // 높이를 부모의 높이에 맞추려면 auto 또는 필요한 높이로 지정
           height: 'auto',
           width: 'auto',
           display: 'flex',
           alignItems: 'center',    // 수직 가운데 정렬
           justifyContent: 'center',// 수평 가운데 정렬
           p: 1,
         }}
      >
         <Typography variant="h6" align="center" sx = {{py : 3}}>
            {title}
         </Typography>
      </Paper>
    </Box>
  );
};

export default LeftNavigationBar;
